export default __webpack_public_path__ + "static/media/cover4.dd4a8039.jpg";